/* :: Import Local
{+} ---------------------------------- */
import Router from './util/Router';
import core from './bootstrap'

/* :: Router Setup
{+} ---------------------------------- */
const routes = new Router({
  core
});

/* :: Load!
{+} ---------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  routes.loadEvents();

  const activities = document.getElementById('category-select');
  if (activities) {
    activities.addEventListener('change', (e) => {
          window.location = `/category/${e.target.value}`
      });
  }

  const testimonials = document.querySelector('[data-testimonials]')
  if (testimonials) {
    const triggers = [...testimonials.querySelectorAll('[data-testimonials-trigger]')]
    const contents = [...testimonials.querySelectorAll('[data-testimonials-content]')]
    if (triggers && contents) {
      const reset = () => {
        triggers.forEach(trigger => trigger.classList.remove('active'))
        contents.forEach(content => content.classList.add('hidden')) 
      }
      triggers.forEach(trigger => {
        trigger.addEventListener('click', function() {
          reset()
          this.classList.add('active')
          const id = this.getAttribute('data-testimonials-trigger')
          const target = contents.filter(content => content.getAttribute('data-testimonials-content') == id)[0]
          target.classList.remove('hidden')
        })
      })
    }
  }
  

    const topLevelLinks = [...document.querySelectorAll('.hoverable > a')] 

    topLevelLinks.forEach(link => {
        link.addEventListener('focus', function() {
          link.nextElementSibling.classList.remove('hidden')
          document.addEventListener('keyup', event => {
              if (event.keyCode == 27) link.nextElementSibling.classList.add('hidden')
          })
        })
      
        if (link.nextElementSibling) {
          const subMenu = link.nextElementSibling
          const subMenuLinks = subMenu.querySelectorAll('a')
          const lastLinkIndex = subMenuLinks.length - 1
          const lastLink = subMenuLinks[lastLinkIndex]
      
          lastLink.addEventListener('blur', function() {
            link.nextElementSibling.classList.add('hidden')
          })
        }
      })

      const tabs = document.querySelectorAll(".tabs");
      const tab = document.querySelectorAll(".tab");
      const panel = document.querySelectorAll(".tab-content");
      
      function onTabClick(event) {
      
        // deactivate existing active tabs and panel
      
        for (let i = 0; i < tabs.length; i++) {
          tabs[i].classList.remove("active");
        }

        for (let i = 0; i < tab.length; i++) {
          tab[i].classList.remove("active");
        }
      
        for (let i = 0; i < panel.length; i++) {
          panel[i].classList.remove("active");
        }
      
      
        // activate new tabs and panel
        event.target.classList.add('active');
        let classString = event.target.getAttribute('data-target');
        console.log(classString);
        document.getElementById('panels').getElementsByClassName(classString)[0].classList.add("active");
      }
      
      for (let i = 0; i < tab.length; i++) {
        tab[i].addEventListener('click', onTabClick, false);
      }
});
